import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Lottie from "lottie-react";

import { setAnimation } from '../../redux-root/actions';

import styles from './index.module.css';

function AnimationPage(props) {
  const { animation } = props;

  return (
    <div className={styles['wrapper']}>
      <Lottie
        animationData={animation}
        onLoopComplete={() => props.setAnimation(null)}
        className={styles['animation']} />
    </div>
  );
}

const mapStateToProps = state => ({
  animation: state.app.animation
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setAnimation
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AnimationPage);
